export const WORKER_AVAILABILITIES_PATH = "availabilities";
